import "./regularList.css";
import { ListItems } from "./list-items";
import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router";
import { FaTimes, FaCheck, FaExpand } from "react-icons/fa";
import { BsPlusCircleFill } from "react-icons/bs";
import { MdLock, MdPublic } from "react-icons/md";
import { Backdrop } from "@material-ui/core";
import { QuickAdd } from "./quickAdd";
import { updateList } from "../api-interactions/lists";
import { getCookie } from "../helperFunctions/cookie";

export const RegularList = (props) => {
  const [list, setList] = useState(props.list);
  const [expandList, setExpandList] = useState(false);
  const [quickAdd, setQuickAdd] = useState(false);
  const navigate = useNavigate();
  const listPath = "/dashboard/lists/" + props.list._id;
  const user = JSON.parse(localStorage.getItem("user"));

  const clickHandler = (accepted, index) => {
    const jwt = getCookie();
    if (accepted) {
      const item = list.needAccept[index];
      // setList((prevState) => {
      //   const newList = prevState.items.push(item);
      //   return newList;
      // });
      list.items.push(item);
    }
    list.needAccept.splice(index, 1);
    updateList(jwt, list._id, list);
    navigate("/dashboard/lists/" + list._id);
  };

  return (
    <>
      {expandList && (
        <div>
          <Navigate to={listPath} />
        </div>
      )}
      <div className="regular-list-container">
        <div id="regular-list-header">
          {props.list.public && (
            <h2>
              {<MdPublic className="privacy-icon" />} {props.list.title}
            </h2>
          )}
          {props.list.public === false && (
            <h2>
              {<MdLock className="privacy-icon" />} {props.list.title}
            </h2>
          )}
          <FaExpand id="expand-btn" onClick={() => setExpandList(true)} />
        </div>
        {(props.list.addBtn || props.list.owner === user.email) && (
          <BsPlusCircleFill
            onClick={() => setQuickAdd(true)}
            className="add-btn"
          />
        )}

        {list.needAccept && (
          <ListItems items={list.items} list={list} fullHeight={false} />
        )}
        {!list.needAccept && (
          <ListItems items={list.items} list={list} fullHeight={true} />
        )}

        {list.needAccept && (
          <div id="suggestions-container">
            {list.needAccept &&
              list.needAccept.map((value, index) => {
                return (
                  <p className="suggestion">
                    <span>{value.addedBy}</span> - {value.name}
                    <div>
                      {value.addedBy !== user.userName && (
                        <FaCheck
                          id="accept"
                          onClick={() => clickHandler(true, index)}
                        />
                      )}
                      <FaTimes
                        id="deny"
                        onClick={() => clickHandler(false, index)}
                      />
                    </div>
                  </p>
                );
              })}
          </div>
        )}

        {quickAdd && (
          <Backdrop open={true} id="full-backdrop">
            <QuickAdd list={props.list} setQuickAdd={setQuickAdd} />
          </Backdrop>
        )}
      </div>
    </>
  );
};
